import AriaLabel from "@mobi/components/AriaLabel"
import Icon from "@mobi/ds/components/Icon"
import Text from "@mobi/ds/components/Text"

import "./style.scss"

const CardFirst = () => (
  <div className="cardAccountHolder">
    <Text as="h3" className="cardAccountHolder__title">
      é correntista Itaú?
    </Text>
    <Text as="p" className="cardAccountHolder__text">
      Você também pode consultar o andamento da sua proposta através do Itaú na
      internet ou pelo app nos caminhos:
    </Text>
    <div className="cardAccountHolder__infoContainer">
      <div className="cardAccountHolder__iconContainer">
        <Icon
          icon="computador"
          className="cardAccountHolder__icon"
          alt="Ícone de computador"
          aria-hidden="true"
        />
      </div>
      <AriaLabel ariaText="No computador, acesse: Menu, Crédito, Crédito com Garantia de Imóvel, Acompanhar sua proposta">
        <Text as="p" className="cardAccountHolder__text" aria-hidden="true">
          Menu &gt; Crédito &gt; Crédito com Garantia de Imóvel &gt; Acompanhar
          sua proposta
        </Text>
      </AriaLabel>
    </div>
    <div className="cardAccountHolder__infoContainer">
      <div className="cardAccountHolder__iconContainer">
        <Icon
          icon="celular"
          className="cardAccountHolder__icon"
          alt="Ícone de celular"
          aria-hidden="true"
        />
      </div>
      <AriaLabel ariaText="No aplicativo, acesse: Serviços, Crédito, Crédito com Garantia de Imóvel, Acompanhar sua proposta">
        <Text as="p" className="cardAccountHolder__text" aria-hidden="true">
          Serviços &gt; Crédito &gt; Crédito com Garantia de Imóvel &gt;
          Acompanhar sua proposta
        </Text>
      </AriaLabel>
    </div>
  </div>
)

export default CardFirst
